module.exports = __webpack_public_path__ + "media/images/spec_help_2x-a178adf1.jpg";